import { useCallback } from 'react';

import { MAX_MACHINES, MIN_MACHINES } from '@components/tenantStatus/onboardingWizard/constants';
import type { NumberStepperProps } from '@components/tenantStatus/onboardingWizard/types';

export type UseManageNumberStepperParams = Pick<NumberStepperProps, 'value' | 'onChange'>;

export const useManageNumberStepper = ({ value, onChange }: UseManageNumberStepperParams) => {
  const handleDecrement = useCallback(() => onChange(Math.max(MIN_MACHINES, value - 1)), [onChange, value]);
  const handleIncrement = useCallback(() => onChange(Math.min(MAX_MACHINES, value + 1)), [onChange, value]);

  return { handleDecrement, handleIncrement };
};
